import React, { useState } from 'react';

// Form pieces shared by the Sign In / Sign Up screens (screens/Login.png, screens/SignUp.png).
// Each field is a `.form-group` so jquery-validation's errorPlacement drops its message under the input.

const MailIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3.5 6.5 8.5 6 8.5-6" /></svg>
);

const LockIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /><circle cx="12" cy="16" r="1" /></svg>
);

const EyeIcon = ({ off }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
    <circle cx="12" cy="12" r="3" />
    {off && <path d="M4 4l16 16" />}
  </svg>
);

export const ArrowIcon = () => (
  <svg className="ib-auth-btn__arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
);

export const EmailField = ({ id, name = 'email', value, onChange, placeholder = 'Enter your email' }) => (
  <div className="form-group ib-field">
    <label htmlFor={id}>Email</label>
    <div className="ib-input">
      <span className="ib-input__icon"><MailIcon /></span>
      <input
        id={id}
        name={name}
        type="email"
        className="form-control"
        placeholder={placeholder}
        autoComplete="email"
        value={value}
        onChange={onChange}
      />
    </div>
  </div>
);

export const PasswordField = ({ id, name, label, value, onChange, placeholder, autoComplete = 'current-password' }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="form-group ib-field">
      <label htmlFor={id}>{label}</label>
      <div className="ib-input">
        <span className="ib-input__icon"><LockIcon /></span>
        <input
          id={id}
          name={name}
          type={visible ? 'text' : 'password'}
          className="form-control ib-input--with-toggle"
          placeholder={placeholder}
          autoComplete={autoComplete}
          value={value}
          onChange={onChange}
        />
        <button
          type="button"
          className="ib-input__toggle"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? 'Hide password' : 'Show password'}
        >
          <EyeIcon off={!visible} />
        </button>
      </div>
    </div>
  );
};

export const OrDivider = () => <div className="ib-auth-or"><span>OR</span></div>;
